/*
 * @Descripttion: 
 * @version: V1.0.0
 * @Author: zym
 * @Date: 2023-11-13 22:13:33
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css/normalize.css'
import baseUtil from './utils/utils'
import { Icon, Uploader, Swipe, SwipeItem, Toast } from 'vant';
import axios from "./utils/request";
import api from "./utils/api.url";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vconsole from 'vconsole'
if (process.env.VUE_APP_ENV === 'dev') {
  new Vconsole({
    // 兼容可回溯
    onReady: () => {
      const dom = document.getElementById('__vconsole')
      if (dom) {
        dom.classList.add('txr-ignore')
        dom.classList.add('txr-block')
      }
    }
  })
}
Vue.use(Viewer)
Viewer.setDefaults({
  title: false,
  toolbar: false,
  navbar: false,
  button: false
})
Vue.use(Icon);
Vue.use(Uploader);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Toast);

Vue.config.productionTip = false
Vue.prototype.baseUtil = baseUtil
Vue.prototype.$http = axios;
Vue.prototype.$api = api;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
